import PropTypes from 'prop-types'

const SimpleCheckList = ({ children }) => (
  <div className="p-4 my-3 bg-gray-800 rounded-lg shadow-lg dark:bg-content1">
    { children }
  </div>
)

SimpleCheckList.propTypes = {
  children: PropTypes.node.isRequired,
}

export default SimpleCheckList